export default "__VITE_ASSET__A589bWZO__"